/**
 * local storage key name に pathname hash を付与する時の hash を生成します
 * @param {string} str hash 生成する文字列
 * @return {string} hash
 */
const hash = str => window.btoa(unescape(encodeURIComponent(str)));

export default hash;



// WEBPACK FOOTER //
// ./src/phase2/survey/app/hash.js